import { Category } from 'src/app/shared/interfaces/category';

// The category cards (block-categories). TODO(operator): PrimeHat's own - each a category that holds products, with a
// subtitle naming what it really holds. None yet: the izz host's list described its own catalogue.
export const top_categories: Category[] = [];
